import './_copy-right.scss';
export default function CopyRight() {
    return (<div className="copy-right">
        {/*<span>&#169;2024 Bryto LLC</span>*/}
    </div>);
}
